// Query hooks for Add New Listing
'use client';

import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { ApiFnReturnType } from '@/slw/shared/query-client';

import { fetchDropdownData, checkZipCode, checkVin, getUserPackages, getListing } from './listing.api';

export const LISTING_QUERY_KEY = 'listing';

export function useListing(url: string) {
  const queryClient = useQueryClient();

  const query = useQuery<ApiFnReturnType<typeof getListing>>({
    queryKey: [LISTING_QUERY_KEY, url],
    queryFn: () => getListing(url),
    enabled: !!url,
  });

  useEffect(() => {
    return () => queryClient.removeQueries({ queryKey: [LISTING_QUERY_KEY, url] });
  }, [queryClient, url]);

  return query;
}

export function useDropdownData(type: string) {
  return useQuery({
    queryKey: ['dropdown', type],
    queryFn: () => fetchDropdownData(type),
    staleTime: 60 * 60 * 1000, // 1h
  });
}

export function useCheckZipCodeQuery(countryCode: string, zipCode: string) {
  return useQuery({
    queryKey: ['check-zip-code', countryCode, zipCode],
    queryFn: () => checkZipCode(countryCode, zipCode),
    enabled: !!countryCode && !!zipCode,
  });
}

export function useCheckVin(vin: string) {
  return useQuery({
    queryKey: ['check-vin', vin],
    queryFn: () => checkVin(vin),
    enabled: !!vin,
  });
}

export function useUserPackages() {
  return useQuery({
    queryKey: ['user-package'],
    queryFn: () => getUserPackages(),
  });
}
